import { Button } from '@wonderschool/common-base-ui';
import { QRCodeSVG } from 'qrcode.react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
// eslint-disable-next-line no-restricted-imports
import { Card, Icon, Image, Modal, Segment } from 'semantic-ui-react';

// Import asset
import wsLogo from '../../assets/images/wonderschool/logo-base.png';
import OrgQrPrintCard from '../Shared/OrgQrPrintCard';

const OrganizationQRCode = ({ currentOrganization: { id, name } }) => {
  const [open, setOpen] = useState(false);
  const [print, setPrint] = useState(false);
  const { t } = useTranslation();

  // Listen to print event managed by in-modal print button
  useEffect(() => {
    if (print) {
      window?.print();
    }
  }, [print]);

  useEffect(() => {
    if (window) {
      window.onafterprint = () => {
        setPrint(false);
      };
    }
  }, []);

  return (
    <Modal
      className="qr-code"
      size="small"
      centered={false}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      closeOnDimmerClick={true}
      trigger={
        <Button primary preIcon={<Icon name="qrcode" />}>
          {t('locations.qrCode.viewPrintAction')}
        </Button>
      }
    >
      <Modal.Content>
        {/* Shared hidden print card — printing shows only this, not the modal/page. */}
        <OrgQrPrintCard value={id} organizationName={name} />
        <Card centered fluid>
          <Segment basic textAlign="center">
            <QRCodeSVG
              size={256}
              value={id}
              fgColor="#28325A"
              includeMargin
              level="Q"
              // TODO: Adding a logo in the middle of the QR code will be cool in the future
              // imageSettings={{
              //   src: wsLogo,
              //   excavate: true,
              //   height: 100,
              //   width: 100,
              // }}
            />
          </Segment>
          <Card.Content>
            <Card.Header textAlign="justify" style={{ fontSize: '1.5em', lineHeight: '1.5em' }}>
              {t('qrCode.title')}
            </Card.Header>
            <Card.Meta style={{ fontSize: '1.5em', lineHeight: '1.5em' }}>
              <ol
                style={{ display: 'inline-block', paddingLeft: '1.2em', textAlign: 'left', listStyleType: 'decimal' }}
              >
                <li>{t('qrCode.step1')}</li>
                <li>{t('qrCode.step2')}</li>
                <li>{t('qrCode.step3')}</li>
                <li>{t('qrCode.step4')}</li>
                <li>{t('qrCode.step5')}</li>
              </ol>
            </Card.Meta>
          </Card.Content>

          <Card.Content extra textAlign="center">
            <Image src={wsLogo} size="small" alt="Wonderschool logo" centered />
          </Card.Content>

          <Card.Content textAlign="center">
            <div className="print:hidden">
              <Button primary onClick={() => setPrint(true)}>
                {t('common.organization.qrCode')}
              </Button>
            </div>
          </Card.Content>
        </Card>
      </Modal.Content>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  currentOrganization: state.organizations.currentOrganization,
});

export default connect(mapStateToProps, null)(OrganizationQRCode);
